import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faUserCircle, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../config/api.config';
import './LoginForm.css';

const LoginForm = ({ onLoginSuccess }) => {
  const [isRegistering, setIsRegistering] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (isRegistering && !phone.trim()) {
      setError('Phone number is required.');
      return;
    }

    if (isRegistering && password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    const action = isRegistering ? 'register' : 'login';
    const payload = isRegistering
      ? { name, email, phone: phone.trim(), password }
      : { username: email, password };

    fetch(`${API_BASE_URL}?action=${action}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'ok') {
          localStorage.setItem('user', JSON.stringify(data.user));
          if (onLoginSuccess) onLoginSuccess(data.user);
        } else {
          setError(data.message || 'Login failed');
        }
      })
      .catch(() => setError('Login error. Please try again.'));
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-icon">
            <FontAwesomeIcon icon={isRegistering ? faUserCircle : faShieldAlt} />
          </div>
          <h1 className="login-title">
            {isRegistering ? 'Create your AlamCareRx account' : 'Welcome back to AlamCareRx'}
          </h1>
          <p className="login-subtitle">
            {isRegistering
              ? 'Register now to save favourites, cart items, and enjoy faster checkout.'
              : 'Login to access your orders, favorites, saved cart, and pharmacy offers.'}
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {isRegistering && (
            <div className="new-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="Enter your full name"
              />
            </div>
          )}

          <div className="new-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
          </div>

          {isRegistering && (
            <div className="new-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                placeholder="03XX XXXXXXX"
              />
            </div>
          )}

          <div className="new-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-container">
              <input
                type={passwordVisible ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder={isRegistering ? 'Create a strong password' : 'Password'}
              />
              <FontAwesomeIcon
                icon={passwordVisible ? faEyeSlash : faEye}
                className="password-visibility-icon"
                onClick={() => setPasswordVisible((v) => !v)}
              />
            </div>
          </div>

          {isRegistering && (
            <div className="new-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <div className="password-input-container">
                <input
                  type={confirmPasswordVisible ? 'text' : 'password'}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder="Re-enter your password"
                />
                <FontAwesomeIcon
                  icon={confirmPasswordVisible ? faEyeSlash : faEye}
                  className="password-visibility-icon"
                  onClick={() => setConfirmPasswordVisible((v) => !v)}
                />
              </div>
            </div>
          )}

          <div className="new-group remember-me">
            <input type="checkbox" id="rememberMe" />
            <label htmlFor="rememberMe">Remember Me</label>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button">
            {isRegistering ? 'Create Account' : 'Login'}
          </button>

          <div className="login-footer">
            {isRegistering ? (
              <p>
                Already have an account?{' '}
                <button type="button" className="switch-mode" onClick={() => setIsRegistering(false)}>
                  Login
                </button>
              </p>
            ) : (
              <p>
                Don’t have an account?{' '}
                <button type="button" className="switch-mode" onClick={() => setIsRegistering(true)}>
                  Register now
                </button>
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
